module.exports = __webpack_public_path__ + "static/media/NeedsForSpeed.8230a58f.svg";